const altByIcon = {
  'play': 'Play icon',
  'close': 'Close icon',
  'arrow-left': 'Arrow left icon',
  'arrow-right': 'Arrow right icon',
  'info': 'Info icon',
  'book': 'Book icon',
  'content-download': 'Download icon',
}
  
export type TypeAppIcon = keyof typeof altByIcon
export const iconByName = (iconName: TypeAppIcon) => ({
  type: 'svg' as const,
  src: `/images/svg/i--${iconName}.svg`,
  alt: altByIcon[iconName],
  size: { width: 24, height: 24 }
})
  